import * as FileSaver from 'file-saver';
import axios from './axios';

declare interface myWindowNavigator extends Navigator {
    msSaveOrOpenBlob: (b: Blob, fileName: string) => void;
}

declare interface myWindow extends Window {
    navigator: myWindowNavigator;
}
declare const window: myWindow;

declare const saveAs: typeof FileSaver.saveAs;

export function Download(fileName: string, content: string, mime: string) {
    if (window.navigator && 'msSaveOrOpenBlob' in window.navigator) {
        const b = new Blob([content], { type: mime });
        window.navigator.msSaveOrOpenBlob(b, fileName);
    } else {
        const f = new File([content], fileName, { type: mime });
        const url = URL.createObjectURL(f);
        window.location.assign(url);
        URL.revokeObjectURL(url);
    }
}

export declare interface Source {
    url?: string;
    blob?: Blob;
    base64?: string;
}

const b64toBlob = (b64Data: string, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays: Uint8Array[] = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
};

export async function DownloadURL(fileName: string, source: Source) {
    if (!source.blob && source.base64) {
        source.blob = b64toBlob(source.base64);
    }

    if (!source.blob && source.url) {
        const resp = await axios.get<Blob>(source.url, {
            responseType: 'blob',
            withCredentials: false,
        });
        source.blob = resp.data;
    }

    if (!source.blob) {
        throw new Error('source needs to result in a blob');
    }

    saveAs(source.blob, fileName);
}

export async function URLAsDataURL(url: string): Promise<string> {
    const resp = await axios.get(url, { responseType: 'blob' });

    return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const { result } = reader;
            if (typeof result === 'string') {
                resolve(result);
            } else {
                reject(new Error('Unexpected result type when converting Blob to DataURL'));
            }
        };
        reader.onerror = () => reject(reader.error ?? new Error('FileReader error'));
        reader.readAsDataURL(resp.data as Blob);
    });
}